const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '通过官方认证入口访问，保障您的信息安全，远离仿冒网站风险，让每一次访问都安心无忧。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '完美支持电脑、手机、平板等多种设备，随时随地访问，享受一致的使用体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速访问',
    description: '优化的网络架构带来飞一般的加载速度，无需漫长等待，打开网页即刻使用全部功能。',
  },
  {
    icon: 'ri-user-star-line',
    title: '无需注册',
    description: '核心功能完全免费，无需注册账号即可直接体验，降低使用门槛，让您快速上手。',
  },
  {
    icon: 'ri-tools-line',
    title: '功能丰富',
    description: '涵盖文档处理、图片编辑、格式转换等多种实用工具，满足日常办公和生活的各类需求。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '提供详细的使用教程和常见问题解答，遇到问题随时查阅，助您轻松解决使用困惑。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            为什么选择免费91网页
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            数百万用户的选择，免费91网页为您提供安全、便捷、高效的在线服务体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold font-heading text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}